module.exports = __webpack_public_path__ + "media/app-store/modal-close-e48d0c1d.png";